import React, { useEffect, useState } from "react";
import { ApiGetAllPeriodos } from "../../../api/periodos";
import { ApiGetAllComidas } from "../../../api/comidas";
import CrearComidaPeriodo from "../../../components/admin/comidasPeriodo/comidasPeriodo";
import ListadoComidasPeriodo from "../../../components/admin/comidasPeriodo/listadoComidasPeriodo";

const initialState = {
  pre_periodo_id: "",
  pre_comida_id: "",
  horas_antes: "",
  maximo_persona: "",
  subsidio: "",
};

const ComidasPeriodo = () => {
  const [updateList, setUpdateList] = useState(false);
  const [type, setType] = useState("save");
  const [state, setState] = useState(initialState);
  const [listadoPeriodos, setListadoPeriodos] = useState([]);
  const [listadoComidas, setListadoComidas] = useState([]);

  useEffect(() => {
    const fetchPeriodos = async () => {
      const response = await ApiGetAllPeriodos();
      if (response.sms === "ok") {
        const periodosActivos = response.data.filter(
          (periodo) => periodo.estado === true
        );
        setListadoPeriodos(periodosActivos);
      } else {
        console.log(response);
      }
    };

    const fetchComidas = async () => {
      const response = await ApiGetAllComidas();
      if (response.sms === "ok") {
        const comidasActivas = response.data.filter(
          (comida) => comida.estado === true
        );
        setListadoComidas(comidasActivas);
      } else {
        console.log(response);
      }
    };

    fetchPeriodos();
    fetchComidas();
  }, [updateList]);

  const updateListFn = () => {
    setUpdateList(!updateList);
  };

  const resetState = () => {
    setState(initialState);
  };

  return (
    <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
      <CrearComidaPeriodo
        updateListFn={updateListFn}
        state={state}
        setState={setState}
        type={type}
        setType={setType}
        resetState={resetState}
        listadoPeriodos={listadoPeriodos}
        listadoComidas={listadoComidas}
      />
      <ListadoComidasPeriodo
        updateList={updateList}
        updateListFn={updateListFn}
        setState={setState}
        setType={setType}
        listadoPeriodos={listadoPeriodos}
        listadoComidas={listadoComidas}
      />
    </div>
  );
};

export default ComidasPeriodo;
